module.exports = "c6f5610b7d72277c6b2f5b038cd37f37.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/temple-roof-edge-R.png
// module id = 49
// module chunks = 0